import React from "react";
import "./App.css";

function App() {
  return <h1>Main</h1>;
}

export default App;
